<!-- 网银支付页面 -->
<template>
  <div class="payment">
    <div
      style="
        height: 80px;
        background-color: #0065b3;
        padding: 0 285px;
        display: flex;
        justify-content: space-between;
      "
    >
      <div style="color: #fff; line-height: 80px; font-size: 28px">
        支付服务
      </div>
      <!-- <div style="color: #fff; line-height: 100px; display: flex">
        <i class="el-icon-headset" style="line-height: 100px"></i>&nbsp;&nbsp;
        <div>客服电话</div>
        &nbsp;&nbsp;&nbsp;
        <div style="font-size: 22px">95534</div>
      </div> -->
    </div>
    <el-card
      class="box-card"
      style="
        margin: 40px 285px;
        height: 750px;
        background-color: #fff;
        padding-top: 40px;
      "
    >
      <h3 style="display: flex">
        <div
          style="
            height: 25px;
            margin-left: 10px;
            width: 5px;
            background-color: #0065b3;
            display: inline-block;
          "
        ></div>
        &nbsp;&nbsp;订单支付
      </h3>
      <!-- <div
        style="
          width: 110px;
          background-color: #0065b3;
          color: #fff;
          text-align: center;
          height: 30px;
          line-height: 30px;
        "
      >
        订单支付
      </div> -->
      <div style="display: flex; margin-top: 30px">
        <div style="margin-left: 60px; color: #333">
          订单编号：2416808922633642474
        </div>
        <div style="margin-left: 500px; color: #da0520; font-size: 20px">
          支付金额：2000.00元
        </div>
      </div>
      <div
        style="
          margin: 20px 60px 0 60px;
          padding: 10px;
          height: 550px;
          position: relative;
          overflow: hidden;
        "
      >
        <el-tabs type="border-card">
          <el-tab-pane label="选择网银">
            <div style="display: flex; justify-content: space-between">
              <el-radio
                v-model="radio"
                label="1"
                style="display: flex; align-items: center"
              >
                <img
                  src="../assets/建设银行.png"
                  style="widht: 290px; height: 90px"
                  alt
                />
              </el-radio>
              <el-radio
                v-model="radio"
                label="3"
                style="display: flex; align-items: center"
              >
                <img
                  src="../assets/农业银行.png"
                  style="widht: 290px; height: 90px"
                  alt
                />
              </el-radio>
              <el-radio
                v-model="radio"
                label="2"
                style="display: flex; align-items: center"
              >
                <img
                  src="../assets/交通银行1.png"
                  style="widht: 290px; height: 90px"
                  alt
                />
              </el-radio>
            </div>
            <div
              style="
                display: flex;
                justify-content: space-between;
                margin-top: 20px;
              "
            >
              <el-radio
                v-model="radio"
                label="4"
                style="display: flex; align-items: center"
              >
                <img
                  src="../assets/平安.png"
                  style="widht: 290px; height: 90px"
                  alt
                />
              </el-radio>
              <el-radio
                v-model="radio"
                label="5"
                style="display: flex; align-items: center"
              >
                <img
                  src="../assets/邮政银行.png"
                  style="widht: 290px; height: 90px"
                  alt
                />
              </el-radio>
              <el-radio
                v-model="radio"
                label="6"
                style="display: flex; align-items: center"
              >
                <img
                  src="../assets/招商银行.png"
                  style="widht: 290px; height: 90px"
                  alt
                />
              </el-radio>
            </div>
            <div
              style="
                display: flex;
                justify-content: space-between;
                margin-top: 20px;
              "
            >
              <el-radio
                v-model="radio"
                label="7"
                style="display: flex; align-items: center"
              >
                <img
                  src="../assets/中国工商.png"
                  style="widht: 290px; height: 90px"
                  alt
                />
              </el-radio>
            </div>
          </el-tab-pane>
        </el-tabs>
        <el-button
          type="primary"
          style="position: absolute; bottom: 30px; left: 48%"
          @click="accomplish"
          >完 成</el-button
        >
      </div>
      <div style="display: flex; justify-content: flex-end">
        <i class="el-icon-headset" style="line-height: 25px"></i>&nbsp;&nbsp;
        <div>客服电话</div>
        &nbsp;&nbsp;&nbsp;
        <div style="font-size: 20px">95534</div>
      </div>
    </el-card>
  </div>
</template>

<script>
//这里导入其他文件（组件，工具js，第三方插件js，json文件，图片文件等等）
//import 《组件名称》 from '《组件路径》';

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},

  // 组件名称
  name: "",

  // 这里存放数据
  data() {
    return {
      radio: "",
    };
  },

  // 监听属性 类似于data概念
  computed: {},

  // 监控data中的数据变化
  watch: {},

  // 方法集合
  methods: {
    accomplish() {
      window.sessionStorage.setItem('wangyin',"wangyin")
      this.$router.push("/pay");
    },
  },

  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {},

  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},

  // 生命周期 - 创建之前
  beforeCreate() {},

  // 生命周期 - 挂载之前
  beforeMount() {},

  // 生命周期 - 更新之前
  beforeUpdate() {},

  // 生命周期 - 更新之后
  updated() {},

  // 生命周期 - 销毁之前
  beforeDestroy() {},

  // 生命周期 - 销毁完成
  destroyed() {},

  // 如果页面有keep-alive缓存功能，这个函数会触发
  activated() {},

  // keep-alive缓存离开之后触发
  deactivated() {},
};
</script>

<style scoped>
.payment {
  height: 100%;
  background-color: #f7f8fa;
}
.el-tabs {
  height: 450px;
}
</style>
